import { useCallback, useState } from 'react'

import { FanResponseDto } from '@api'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { Radio, RadioGroup } from '@/components/ui/radio.tsx'
import { useToggleBlockUser } from '@/modules/chatting/hooks/use-toggle-block-user.ts'
import { useToggleRestrict } from '@/modules/chatting/hooks/use-toggle-restrict'
import { ListUser } from '@/modules/chatting/types.ts'

import { DialogProps } from '../types'

interface Props extends DialogProps {
  user: FanResponseDto | ListUser
  onSuccess?: () => void
}

export const BlockUserDialog = ({
  isOpen,
  onClose,
  user,
  onSuccess,
}: Props) => {
  const [blockState, setBlockState] = useState<string>()
  const { restrict, isRestrictLoading } = useToggleRestrict()
  const { blockUser, isBlockUserLoading } = useToggleBlockUser()

  const handleSuccess = useCallback(() => {
    onSuccess?.()
    onClose()
  }, [onSuccess, onClose])

  const handleConfirm = useCallback(() => {
    const action = blockState === 'restrict' ? restrict : blockUser

    action(user.id).then(handleSuccess)
  }, [blockUser, blockState, restrict, user, handleSuccess])

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Block {user.name}</Dialog.Title>
      </Dialog.Header>

      <div className="mt-5">
        <RadioGroup
          onChange={setBlockState}
          className="space-y-4"
        >
          <Radio
            label="Block user from accessing your profile."
            value="block"
            className="items-start"
            labelClassName="text-sm leading-[22px] font-medium"
            buttonClassName="h-5 w-5"
          />
          <Radio
            label="Restrict, user will not be able to send you direct messages or reply to your posts."
            value="restrict"
            className="items-start"
            labelClassName="text-sm leading-[22px] font-medium"
            buttonClassName="h-5 w-5"
          />
        </RadioGroup>
      </div>

      <Dialog.Footer className="flex gap-2">
        <Button
          variant="outline"
          onClick={onClose}
          className="flex-1"
        >
          Cancel
        </Button>
        <Button
          disabled={!blockState}
          onClick={handleConfirm}
          isLoading={isBlockUserLoading || isRestrictLoading}
          className="flex-1"
        >
          Confirm
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
